import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { BLACK, WHITE, PAGE_WIDTH } from '../../../styles/variables.style';
import media from '../../../styles/media.style';

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-grow: 1;
  flex-direction: column;
  max-width: ${PAGE_WIDTH}px;
  height: 100%;
  min-height: 100vh;
  // background: linear-gradient(90deg, #a7b9c7 -40%, white, #a7b9c7 140%);
  overflow: hidden;
`;
export const ContentContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow-y: scroll;
  margin: 85px auto 0;
  ${media.tabletP`
    margin: 150px auto 0;
    width: 728px;
  `};
`;
export const TitleText = styled.div`
  text-align: center;
  color: ${BLACK};
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 3px;
  margin-bottom: 40px;
  padding: 0 34px;
  ${media.tabletP`
    font-size: 30px;
  `};
`;
export const DescriptionText = styled.div`
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  color: ${BLACK};
  padding: 5px;
  margin-bottom: 22px;
  ${media.tabletP`
    font-size: 16px;
    margin-bottom: 40px;
  `};
`;
export const ItemWrap = styled.ul`
  width: 100%;
  height: 100%;
  overflow: hidden;
  padding: 0 21px 24px 21px;
  margin-bottom: 0;

  ${media.tabletP`
    width: 728px;
    padding: 0 0 60px 0;
    margin-bottom: unset;
  `};
`;
export const ItemList = styled.li`
  position: relative;
  height: 100%;
  background-color: ${WHITE};
  box-shadow: 0px 2px 9px 1px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: row;
  padding: 46px 20px 20px 20px;
  :not(:last-child) {
    margin-bottom: 10px;
  }
  ${media.tabletP`
    padding: 37px 22px 22px 22px;
    width: 728px;
  `};
`;
export const ImageCover = styled.div`
  justify-content: center;
  align-items: center;
  margin-right: 20px;
  ${media.tabletP`
    margin-right: 22px;
  `};
`;
export const SectionText = styled.div`
  display: flex;
  flex-direction: column;
  opacity: 1;
`;
export const SectionTextTitle = styled.h2`
  font-size: 16px;
  letter-spacing: 1px;
  color: ${BLACK};
  margin-bottom: 25px;
  margin-top: 10px;
  ${media.tabletP`
    font-size: 22px;
    margin-top: 10px;
    margin-bottom: 25px;
  `};
`;
export const SectionTextTitleName = styled.div`
  font-size: 11px;
  letter-spacing: 1px;
  color: #888888;
  ${media.tabletP`
    font-size: 12px;
    margin-bottom: 15px;
  `};
`;
export const SectionTextVariantTitle = styled.div`
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 12px;
  letter-spacing: 1px;
  color: ${BLACK};
  margin-bottom: 10px;
`;
export const SectionTextVariantDesc = styled.div`
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 1px;
  color: ${BLACK};
  margin-bottom: 20px;
`;
export const Package = styled.div`
  font-size: 12px;
  letter-spacing: 1px;
  color: ${BLACK};
`;
export const HowToUseContainer = styled.div`
  margin-top: 20px;
  position: relative;
  height: 40px;
`;
export const HowToUseButton = styled(Link)`
  position: absolute;
  right: 0;
  top: 0;
  width: 132px;
  height: 40px;
  background-color: #959b9e;
  text-align: center;
  border: none;
  color: ${WHITE};
  cursor: pointer;
  display: block;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 1px;
  line-height: 40px;
  outline: none;
`;

export const LabelIcon = styled.div`
  position: absolute;
  height: 21px;
  background-color: ${({ color }) => color || '#dcc787'};
  font-size: 10px;
  border-radius: 14px;
  color: ${WHITE};
  right: 10px;
  top: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 13px;

  ${media.tabletP`
   font-size: 14px;
   width: 98px;
   height: 27px;
   right: 20px;
   top: 22px;
   padding: 0;
 `};
`;



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/SublimicHomeCareItemDetailPage/SublimicHomeCareItemDetailPage.style.js